import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import InlineList from 'components/InlineList';
import { TeamPill } from 'components/Pill';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import { useFormFieldContext } from 'components/FormField/FormFieldContext';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TeamsList(_ref) {
  var teams = _ref.teams,
    onRemoveTeam = _ref.onRemoveTeam,
    title = _ref.title,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var titleId = useUniqueId();
  if (title) {
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      role: "group",
      "aria-labelledby": titleId,
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Text, {
          id: titleId,
          children: title
        }), /*#__PURE__*/_jsx(HintTooltip, {
          content: description,
          spacingLeft: "xs",
          vAlign: false
        })]
      }), /*#__PURE__*/_jsx(InlineList, {
        spacing: "xxs",
        "aria-labelledby": labelId,
        children: teams.map(function (team) {
          var id = team.id;
          return /*#__PURE__*/_jsx(TeamPill, {
            team: team,
            onDelete: function onDelete() {
              return onRemoveTeam(id);
            },
            deleteLabel: t('actions_remove_team')
          }, id);
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    children: teams.map(function (team) {
      var id = team.id;
      return /*#__PURE__*/_jsx(TeamPill, {
        team: team,
        onDelete: function onDelete() {
          return onRemoveTeam(id);
        },
        deleteLabel: t('actions_remove_team')
      }, id);
    })
  });
}
export default TeamsList;